import { Component, Input } from '@angular/core';
import { DatagridError } from '@zipari/shared-ds-util-datagrid';

@Component({
  selector: 'datagrid-error',
  templateUrl: './datagrid-error.component.html',
  styleUrl: './datagrid-error.component.scss',
})
export class DatagridErrorComponent {
  @Input() error: DatagridError;
}
